import React, { useState } from "react";
import "./Projets.css";

export default function Projets() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    role: "",
    message: "",
  });
  const [status, setStatus] = useState({ sending: false, error: "" });

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ sending: true, error: "" });
    try {
      // ⇩ branche ton backend ici
      await new Promise((r) => setTimeout(r, 600));
      alert("Merci ! Nous revenons vers vous rapidement.");
      setStatus({ sending: false, error: "" });
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        role: "",
        message: "",
      });
    } catch {
      setStatus({ sending: false, error: "Un problème est survenu. Réessayez." });
    }
  };

  return (
    <main className="page page-projets" role="main">
      {/* ===== HERO ===== */}
      <section className="proj-hero" aria-labelledby="proj-title">
        <div className="container">
          <header className="proj-hero-header">
            <h1 id="proj-title" className="proj-title">Projets collaboratifs</h1>
            <p className="proj-subtitle">
              OPENlift communique avec la majorité des ascenseurs et peut s’installer sur
              n’importe quelle passerelle. Rendez la vôtre compatible : on vous accompagne
              de l’architecture à l’industrialisation.
            </p>
          </header>
        </div>
      </section>

      {/* ===== AVANTAGES ===== */}
      <section className="proj-benefits" aria-labelledby="benefits-title">
        <div className="container">
          <h2 id="benefits-title" className="section-title">Pourquoi collaborer avec nous&nbsp;?</h2>

          <ul className="benefits-grid" aria-label="Avantages clés">
            {/* Interopérabilité */}
            <li className="benefit">
              <h3 className="benefit-title">Interopérabilité immédiate</h3>
              <p className="benefit-text">
                Compatibilité multi-marques <em>out-of-the-box</em> : votre passerelle parle nativement
                aux contrôleurs d’ascenseurs.
                Plus besoin d’identifier qui parle quel protocole : OPENlift fédère et unifie.
              </p>
              <ul className="benefit-list" aria-label="Bénéfices Interopérabilité">
                <li>Accès automatique à une <strong>grande base multi-marques</strong> sans développement spécifique.</li>
                <li><strong>Zero “driver” propriétaire</strong> à maintenir : les évolutions protocolaires sont gérées côté OPENlift.</li>
                <li>API OPENlift <strong>simple à intégrer</strong> pour exposer données, événements et commandes
                    dans votre dashboard ou app en un minimum d’efforts.</li>
              </ul>
            </li>

            {/* Time-to-market */}
            <li className="benefit">
              <h3 className="benefit-title">Time-to-market accéléré</h3>
              <p className="benefit-text">
                Livrez en semaines, pas en mois : kit de démarrage, simulateurs, sandbox API et
                parcours d’intégration guidé pour aller vite sans sacrifier la qualité.
              </p>
              <ul className="benefit-list" aria-label="Bénéfices Time-to-market">
                <li><strong>SDK &amp; exemples prêts à l’emploi</strong> : démarrez votre POC immédiatement.</li>
                <li><strong>Plateforme de test 24/7</strong> : itérez et validez en continu, à distance.</li>
                <li><strong>Moins d’allers-retours projet</strong> : APIs uniformes, docs claires, support réactif.</li>
              </ul>
            </li>

            {/* Qualité & scalabilité */}
            <li className="benefit">
              <h3 className="benefit-title">Qualité &amp; scalabilité opérationnelles</h3>
              <p className="benefit-text">
                Pensé pour le terrain et la montée en charge : supervision temps réel, observabilité de bout en bout
                et bonnes pratiques d’industrialisation pour des déploiements sereins.
              </p>
              <ul className="benefit-list" aria-label="Bénéfices Qualité & scalabilité">
                <li><strong>Alerting &amp; métriques unifiées</strong> (états, logs, événements) pour agir avant l’incident.</li>
                <li><strong>Durcissement &amp; mises à jour OTA</strong> : sécurité et fiabilité maîtrisées à grande échelle.</li>
                <li><strong>SLA &amp; support</strong> qui accompagnent l’exploitation et la croissance de votre parc.</li>
              </ul>
            </li>
          </ul>
        </div>
      </section>

      {/* ===== NOTRE APPROCHE (NAMESPACED) ===== */}
      <section className="proj-process" aria-labelledby="process-title">
        <div className="container">
          <h2 id="process-title" className="section-title">Notre approche</h2>
          <p className="section-deck">
            Un processus clair, itératif et orienté résultats, pour une intégration fiable et exploitable à grande échelle.
          </p>

          <ol className="proj-steps" aria-label="Étapes du projet">
            <li className="proj-step">
              <div className="proj-step-badge" aria-hidden="true">1</div>
              <div className="proj-step-content">
                <h3 className="proj-step-title">Cadrage &amp; Architecture</h3>
                <p className="proj-step-text">
                  Analyse de vos besoins, contraintes réseau, bus et sécurité.
                  Définition de l’architecture cible et des interfaces.
                </p>
              </div>
            </li>

            <li className="proj-step">
              <div className="proj-step-badge" aria-hidden="true">2</div>
              <div className="proj-step-content">
                <h3 className="proj-step-title">Intégration &amp; Prototypage</h3>
                <p className="proj-step-text">
                  Connexion à OPENlift (<strong>SIP</strong>/<strong>MQTT</strong>/<strong>API</strong>), adaptation protocolaire
                  et premiers tests sur banc ou simulateur.
                </p>
              </div>
            </li>

            <li className="proj-step">
              <div className="proj-step-badge" aria-hidden="true">3</div>
              <div className="proj-step-content">
                <h3 className="proj-step-title">Validation terrain</h3>
                <p className="proj-step-text">
                  Essais en conditions réelles, robustesse réseau, supervision et collecte
                  d’événements pour affiner l’intégration.
                </p>
              </div>
            </li>

            <li className="proj-step">
              <div className="proj-step-badge" aria-hidden="true">4</div>
              <div className="proj-step-content">
                <h3 className="proj-step-title">Industrialisation &amp; Support</h3>
                <p className="proj-step-text">
                  Durcissement, documentation et transfert. Accompagnement au déploiement
                  et suivi post-lancement.
                </p>
              </div>
            </li>
          </ol>
        </div>
      </section>

      {/* ===== FORMULAIRE ===== */}
      <section className="proj-form" aria-labelledby="form-title">
        <div className="container">
          <h2 id="form-title" className="section-title">Parlons de votre projet</h2>
        <p className="section-deck">
            Dites-nous en plus et nous revenons vers vous pour cadrer les objectifs, les jalons et le planning.
          </p>

          <form className="contact-form" onSubmit={onSubmit} noValidate>
            <div className="form-row">
              <div className="form-field">
                <label htmlFor="firstName">Prénom</label>
                <input id="firstName" name="firstName" value={form.firstName} onChange={onChange} required />
              </div>
              <div className="form-field">
                <label htmlFor="lastName">Nom</label>
                <input id="lastName" name="lastName" value={form.lastName} onChange={onChange} required />
              </div>
            </div>

            <div className="form-row">
              <div className="form-field">
                <label htmlFor="email">E-mail</label>
                <input id="email" name="email" type="email" value={form.email} onChange={onChange} required />
              </div>
              <div className="form-field">
                <label htmlFor="phone">Téléphone</label>
                <input id="phone" name="phone" value={form.phone} onChange={onChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-field">
                <label htmlFor="company">Entreprise</label>
                <input id="company" name="company" value={form.company} onChange={onChange} />
              </div>
              <div className="form-field">
                <label htmlFor="role">Rôle</label>
                <input id="role" name="role" value={form.role} onChange={onChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-field form-field--full">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows={6}
                  placeholder="Décrivez vos objectifs, votre passerelle cible, vos contraintes…"
                  value={form.message}
                  onChange={onChange}
                />
              </div>
            </div>

            <div className="form-actions">
              <button className="btn-solid" type="submit" disabled={status.sending}>
                {status.sending ? "Envoi…" : "Envoyer"}
              </button>
              {status.error && <p className="submit-error" role="alert">{status.error}</p>}
            </div>
          </form>
        </div>
      </section>
    </main>
  );
}
